var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculadora(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 473,
    viewBox: "0 0 369 473",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M365.916 362.811C365.916 421.906 318.01 469.811 258.916 469.811H110.51C51.416 469.811 3.51001 421.906 3.51001 362.811V110.811C3.51001 51.717 51.416 3.81104 110.51 3.81104H258.916C318.01 3.81104 365.916 51.717 365.916 110.811V362.811Z",
    fill: "#D6552B",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.51 428.643C131.288 428.643 146.51 413.421 146.51 394.643C146.51 375.865 131.288 360.643 112.51 360.643C93.7323 360.643 78.51 375.865 78.51 394.643C78.51 413.421 93.7323 428.643 112.51 428.643Z",
    fill: "#D6552B",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M269.223 339.977C288.001 339.977 303.223 324.755 303.223 305.977C303.223 287.199 288.001 271.977 269.223 271.977C250.445 271.977 235.223 287.199 235.223 305.977C235.223 324.755 250.445 339.977 269.223 339.977Z",
    fill: "#D6552B",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.51 339.811C128.288 339.811 143.51 324.589 143.51 305.811C143.51 287.033 128.288 271.811 109.51 271.811C90.7323 271.811 75.51 287.033 75.51 305.811C75.51 324.589 90.7323 339.811 109.51 339.811Z",
    fill: "#D6552B",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.297 283.14H103.297V327.145H116.297V283.14Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 298.977H87.7949V311.977H131.8V298.977Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M274.223 428.811C293.001 428.811 308.223 413.589 308.223 394.811C308.223 376.033 293.001 360.811 274.223 360.811C255.445 360.811 240.223 376.033 240.223 394.811C240.223 413.589 255.445 428.811 274.223 428.811Z",
    fill: "#D6552B",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M296.513 387.643H252.508V400.643H296.513V387.643Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M317.51 203.77C317.51 227.553 282.877 246.833 240.155 246.833H132.865C90.143 246.833 55.51 227.554 55.51 203.77V102.352C55.51 78.5691 90.143 59.2891 132.865 59.2891H240.154C282.877 59.2891 317.509 78.5691 317.509 102.352V203.77H317.51Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculadora);
export default __webpack_public_path__ + "static/media/calculadora.aa7351de04763d6bbcf05e04e2fc99ce.svg";
export { ForwardRef as ReactComponent };